import { render, staticRenderFns } from "./ApprovedList.vue?vue&type=template&id=105e6143&scoped=true"
import script from "./ApprovedList.vue?vue&type=script&lang=ts"
export * from "./ApprovedList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e6143",
  null
  
)

export default component.exports